<template>
   <div class="crud-wrapper">
      <crud :form-component="BankChartForm" :grid-columns="gridColumns"
            :pageFilters="pageFilters" obj="bankChart">
      </crud>
   </div>
</template>

<script>
   import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
   import BankChartForm from './BankChartForm';

   export default PageClass.extend({
      name: 'BankCharts',

      data () {
         return {
            BankChartForm,

            gridColumns: [
               /*{
                   dataField: 'storeName',
                   caption: 'Empresa',
                   width: 120,
                   groupIndex: 0
               },*/
               {
                  dataField: 'covenantName',
                  caption: 'Convenio',
                  groupIndex: 0,
                  minWidth: 120
               },
               {
                  dataField: 'bankName',
                  caption: 'Banco',
                  minWidth: 120
                  /*groupCellTemplate: (element, info) => {
                      let media = '/static/images/no-image.jpg';
                      let image = info.value;

                      if (image) {
                          let mediaPath = this.$store.state.company.settings.cloudinary.baseUrl;
                          let transformation = 'q_auto:best';
                          media = mediaPath + `image/upload/${transformation}/`;
                          media += image.name;
                      }

                      $(`<div style="background: url('${media}') no-repeat center center; background-size: cover; border-radius: 100%; height: 30px; width: 30px; margin-left:10px;"></div>`)
                          .appendTo(element);


                  }*/
               },
               /*{
                   dataField: 'bankLogo',
                   caption: '',
                   width: 70,
                   cellTemplate: (element, info) => {
                       let media = '/static/images/no-image.jpg';
                       let image = info.value;

                       if (image) {
                           let mediaPath = this.$store.state.company.settings.cloudinary.baseUrl;
                           let transformation = 'q_auto:best';
                           media = mediaPath + `image/upload/${transformation}/`;
                           media += image.name;
                       }

                       $(`<div style="background: url('${media}') no-repeat center center; background-size: cover; border-radius: 100%; height: 36px; width: 36px; margin-left:10px;"></div>`)
                           .appendTo(element);


                   }
               },*/
               {
                  dataField: 'code',
                  caption: 'Código',
                  width: 120
               },
               {
                  dataField: 'name',
                  caption: 'Tabela',
                  minWidth: 150
               },
               {
                  dataField: 'maxTerm',
                  caption: 'Prazo Max.',
                  width: 85
               },
               // {
               //    dataField: 'bestCommission',
               //    caption: 'Comissão',
               //    dataType: 'number',
               //    format: {
               //       type: 'fixedPoint',
               //       precision: 1
               //    },
               //    width: 90
               // },
               // {
               //    dataField: 'bestCommissionSD',
               //    caption: 'Comissão SD',
               //    dataType: 'number',
               //    format: {
               //       type: 'fixedPoint',
               //       precision: 1
               //    },
               //    width: 100
               // },
               // {
               //    dataField: 'bestCommissionLRP',
               //    caption: 'Comissão LRP',
               //    dataType: 'number',
               //    format: {
               //       type: 'fixedPoint',
               //       precision: 1
               //    },
               //    width: 105
               // },
               {
                  dataField: 'createdByName',
                  caption: 'Cadastrado por',
                  minWidth: 90
               },
               {
                  dataField: 'created_at',
                  caption: 'Cadastrada em',
                  dataType: 'date',
                  format: 'dd/MM/yyyy',
                  width: 110
               }
            ]
         };
      },

      created () {

         /*if (!this.hasPageFilters) {
            this.createPageFilters([
               {field: 'exchangeStatusId', value: null, label: ''},
               {field: 'hasDebit', value: false, label: ''}
            ]);

            //Defining default filters
            // this.setPageFilter('dateRange', [this.$util.dateRange.today.start(), this.$util.dateRange.today.start()], 'Em {0}'.format(this.$util.dateRange.today.start('MMM/DD/YYYY')));
         }*/

      }


   });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/BankCharts.vue